/**
 * Map coordinate DTO
 */
export class MapCoordinateDto {
	coordinates?: number[];

	constructor(latitude: number, longitude: number) {
		this.coordinates = [latitude, longitude];
	}

	get latitude(): number | null {
		return this.coordinates?.[0] ?? null;
	}

	get longitude(): number | null {
		return this.coordinates?.[1] ?? null;
	}
}
